import React from "react";
import { useLocation } from "react-router";
import { IoArrowBackCircle } from "react-icons/io5";
import { BsToggleOn, BsToggleOff } from "react-icons/bs";

// Custom Hook import
import { useAddEmployee } from "../../customHooks/Employee/useAddEmployee"; // Assuming path
import AlertModal from "../../components/Alert/AlertModal"; // Assuming path

const EmployeeAddorUpdate = () => {
  const { state } = useLocation();
  const hookProps = useAddEmployee({ state });

  const {
    iEmployeeId,
    sEmployeeCode,
    sName,
    sDesignation,
    sBranch,
    sState,
    sDistrict,
    bEnabled,
    setSEmployeeCode,
    setSName,
    setSDesignation,
    setSBranch,
    setSState,
    setSDistrict,
    setBEnabled,
    isValidEmployeeCode,
    isValidName,
    codeError,
    nameError,
    handleSubmit,
    handleBack,
    response,
    openUpdateAlert,
    handleClose,
  } = hookProps;

  return (
    <>
      <div className="InnerContent formfeilds">
        <div className="Row d-flex">
          <div className="col-md-11">
            <label className="Label" style={{ color: "#a75503" }}>
              {iEmployeeId ? "Edit / Update" : "Add New"} Employee
            </label>
          </div>
          <div className="col-md-1">
            <button className="btn btn-primary" onClick={handleBack}>
              <IoArrowBackCircle size={30} />
            </button>
          </div>
        </div>
        <hr className="mt-3 mb-5" />
        <form onSubmit={handleSubmit}>
          <div className="form-group formfeilds">
            <div className="row mb-4">
              {/* Status Toggle */}
              <div className="col-md-2">
                <div className="row">
                  <div className="col-md-12">
                    <label htmlFor="enable">Enable Employee</label>
                  </div>
                  <div className="col-md-12">
                    <span
                      onClick={() => setBEnabled(!bEnabled)}
                      className="pointer"
                    >
                      {bEnabled ? (
                        <>
                          <BsToggleOn size={35} color={"Green"} />{" "}
                          <span className="color_green">ON</span>
                        </>
                      ) : (
                        <>
                          <BsToggleOff size={35} color={"Red"} />{" "}
                          <span className="color_red">OFF</span>
                        </>
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              {/* Employee Code */}
              <div className="col-md-4">
                <div className="form-group formfeilds">
                  <label htmlFor="employeeCode">
                    Employee Code<span style={{ color: "red" }}> *</span>
                  </label>
                  <input
                    className="FormControl"
                    type="text"
                    value={sEmployeeCode}
                    onChange={(e) => setSEmployeeCode(e.target.value)}
                    onBlur={isValidEmployeeCode}
                    placeholder="Employee Code"
                    disabled={iEmployeeId ? true : false}
                  />
                  <div className="text-left text-small color_red">
                    {codeError}
                  </div>
                </div>
              </div>

              {/* Name */}
              <div className="col-md-4">
                <div className="form-group formfeilds">
                  <label htmlFor="name">
                    Name<span style={{ color: "red" }}> *</span>
                  </label>
                  <input
                    className="FormControl"
                    type="text"
                    value={sName}
                    onChange={(e) => setSName(e.target.value)}
                    onBlur={isValidName}
                    placeholder="Employee Name"
                  />
                  <div className="text-left text-small color_red">
                    {nameError}
                  </div>
                </div>
              </div>

              {/* Designation */}
              <div className="col-md-4">
                <div className="form-group formfeilds">
                  <label htmlFor="designation">Designation</label>
                  <input
                    className="FormControl"
                    type="text"
                    value={sDesignation}
                    onChange={(e) => setSDesignation(e.target.value)}
                    placeholder="Designation"
                  />
                </div>
              </div>
            </div>

            <div className="row">
              {/* Branch */}
              <div className="col-md-4">
                <div className="form-group formfeilds">
                  <label htmlFor="branch">Branch</label>
                  <input
                    className="FormControl"
                    type="text"
                    value={sBranch}
                    onChange={(e) => setSBranch(e.target.value)}
                    placeholder="Branch"
                  />
                </div>
              </div>

              {/* State */}
              <div className="col-md-4">
                <div className="form-group formfeilds">
                  <label htmlFor="state">State</label>
                  <input
                    className="FormControl"
                    type="text"
                    value={sState}
                    onChange={(e) => setSState(e.target.value)}
                    placeholder="State"
                  />
                </div>
              </div>

              {/* District */}
              <div className="col-md-4">
                <div className="form-group formfeilds">
                  <label htmlFor="district">District</label>
                  <input
                    className="FormControl"
                    type="text"
                    value={sDistrict}
                    onChange={(e) => setSDistrict(e.target.value)}
                    placeholder="District"
                  />
                </div>
              </div>
            </div>
          </div>

          <button className="btn btn-primary ml-4" type="submit">
            Save
          </button>
        </form>
      </div>
      <AlertModal
        open={openUpdateAlert}
        handleClose={handleClose}
        handleOk={handleClose}
        title={response}
        showCancel={false}
      />
    </>
  );
};

export default EmployeeAddorUpdate;